import { render, staticRenderFns } from "./v-avatar.vue?vue&type=template&id=4d61d3d1&"
import script from "./v-avatar.vue?vue&type=script&lang=js&"
export * from "./v-avatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports